export enum CheckLimitationRequestTypes {
    Deposit = 1,
    Withdrawal = 2,
    BetweenMyWallet = 3,
    InternalTransfer = 4,
    Buy = 5,
    Sell = 6,
    ExchangeService = 7,
    SmsPanelCharge = 8,
    PointWithdrawal = 9,
    VoucherService = 10
}